import { AccessSharingRole } from 'types/entities/AccessSharingRole';
import { IAccessSharingPermissionType } from 'types/IAccessSharingUser';

export interface CreateFleetRequest {
  name: string;
  exposedEquipmentIds: string[];
}

export interface CreateFleetResponse {
  exposedFleetId: string;
  name: string;
  exposedEquipmentIds: string[];
}

export type UpdateFleetRequest = {
  exposedFleetId: string;
  name: string;
  exposedEquipmentIds?: string[];
};

export interface DeleteFleetRequest {
  exposedFleetId: string;
}

export enum SharedItemShareType {
  FLEET = 'fleet',
  EQUIPMENT = 'equipment',
}

export interface SharedItemSharedWith {
  exposedAccessSharingRecordId: string;
  displayColor: string;
  displayName: string;
  sharedRole: AccessSharingRole;
  email: string;
  startsAt?: string | null;
  endsAt?: string | null;
}

export interface SharedItemDetails {
  shareType: SharedItemShareType;
  exposedId: string;
  exposedEquipmentIds?: string[];
  sharedItemLabel: string;
  ownerDisplayColor: string;
  ownerName: string;
  ownerEmail: string;
  myRole: AccessSharingRole;
}

export interface SharedItem {
  sharedItemDetails: SharedItemDetails;
  sharedWith: SharedItemSharedWith[];
}

export interface SharedItemsResponse {
  equipment: SharedItem[];
  fleets: SharedItem[];
}

export interface UpdateEquipmentUserPermissionsRequest {
  shareType: SharedItemShareType;
  exposedId: string[];
  sharedWith: {
    email: string;
    role: IAccessSharingPermissionType;
    startsAt?: string | null;
    endsAt?: string | null;
  }[];
}

export interface AddNewUserRequest {
  shareType: SharedItemShareType;
  exposedId: string[];
  sharedWith: {
    email: string;
    role: IAccessSharingPermissionType;
    startsAt?: string | null;
    endsAt?: string | null;
  }[];
}
